/* eslint-disable camelcase */
import Image from "next/image";
import NextLink from "next/link";
import { ArrowRight } from "~/components/common/icons";
import { BlogCardProps } from "~/types";

export const BlogCard = ({ image, title, slug }: BlogCardProps) => (
  <NextLink
    className="relative m-auto grid w-full grid-cols-1  rounded-lg pb-[100%]"
    href={`/blog/${slug}`}
  >
    <Image
      src={image || "/assets/images/product-image-placeholder.svg"}
      className="rounded-t-lg"
      layout="fill"
      objectFit="cover"
      alt="Meat"
      priority
    />
    <div className="absolute bottom-0 flex w-full justify-between rounded-b-lg  bg-colorFourteen p-4  font-bold text-colorSix">
      <p className="sm:text-base lg:text-lg">{title}</p>
      <ArrowRight />
    </div>
  </NextLink>
);
